
(function() {
 
    let x = setInterval(function() {
        try {
            let cbbAlsoBoughtProduct = document.querySelectorAll('#corner-cowi-related-items-cards-wrapper .cowi-cart-recommended-item-card-wrapper');
    
            if (cbbAlsoBoughtProduct && cbbAlsoBoughtProduct.length) {
                for (let i = 0; i < cbbAlsoBoughtProduct.length; i++) {

                  if (! cbbAlsoBoughtProduct[i].classList.contains('combowise-altered')) {
                    const link = cbbAlsoBoughtProduct[i].querySelector('.cowi-cart-recommended-item-card-info').href;
                    const atc = cbbAlsoBoughtProduct[i].querySelector(`#cowi-cart-recommended-item-cta-${i}`);
                    const newAtc = atc.cloneNode(true);
                    cbbAlsoBoughtProduct[i].replaceChild(newAtc, atc);
                    if (newAtc.children.length) {
                        newAtc.children[0].innerText = "點擊查看";
                    } else {
                        newAtc.innerText = "點擊查看";
                    }
                    newAtc.addEventListener('click', function() {
                        window.location.href = link;
                    });
  
                    cbbAlsoBoughtProduct[i].classList.add('combowise-altered');
                  }
                }
            }
        } catch (err) {
            console.error('Combowise cart custom script error: ', err);
        }
    }, 1000);
})();


(function() {
  let previousCartState = null;

  function cartsAreEqual(cartA, cartB) {
    return JSON.stringify(cartA) === JSON.stringify(cartB);
  }
  
  async function parseBoxBasicLineProperty(lineProperties) {
    let variantIds = [];
    let handles = []; 

    for (const key in lineProperties) {
        try {
            if (key.toLowerCase().indexOf('box item') > -1) {
                const vals = lineProperties[key].split(',');
                for (const val of vals) {
                    const variant = val.split(':');

                    if (variant[0].trim() == 'id') {
                        const pv = variant[1].trim().split('-');
                        variantIds.push(+pv[1]);
                    }

                    if (variant[0].trim() == 'handle') {
                      handles.push(variant[1].trim());
                    }
                }
            }
        } catch (err) {
            console.error('Error parsing box properties:', err);
        }
    }

    return { variantIds, handles };
  }

  function getVariant(product, variantId) {
    if (!product || !product.variants) {
      console.error('Product or variants data missing');
      return null;
    }
    return product.variants.find(v => v.id === variantId);
  }

  async function removeLineItem(lineId) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineId,
          quantity: 0, // Setting quantity to 0 removes the item
        }),
      });

      if (!response.ok) {
        throw new Error(`Error removing line item: ${response.statusText}`);
      }
      const cart = await response.json();
      console.log('Updated cart:', cart);
      return cart; // Updated cart object
    } catch (error) {
      console.error('Failed to remove line item:', error);
    }
  }
 
  async function fetchCart() {
    try {
      const cartResponse = await fetch('/cart.js');
      const currentCart = await cartResponse.json();

      if (!previousCartState || !cartsAreEqual(previousCartState, currentCart)) { 
        previousCartState = currentCart;
        for (const item of currentCart.items) {
          try {
            const { variantIds, handles } = await parseBoxBasicLineProperty(item.properties);
  
            if (variantIds && variantIds.length === handles.length) {            
              // Fetch all product data for the handles
              const data = await Promise.all(handles.map(h => fetch(`/products/${h}.js`)));
              const datajson = await Promise.all(data.map(d => d.json()));
  
              // Check availability of all variants in the bundle
              let allAvailable = true;
              for (let i = 0; i < variantIds.length; i++) {
                const v = getVariant(datajson[i], variantIds[i]);
                if (!v || !v.available) {
                  console.error(`Variant ${variantIds[i]} for product ${handles[i]} is out of stock`);
                  allAvailable = false;
                  break;  // No need to check further if one variant is out of stock
                }
              }
  
              // If any variant is unavailable, remove the bundle from the cart
              if (!allAvailable) {
                console.log(`Removing bundle ${item.key} from cart due to out of stock variants`);
                await removeLineItem(item.key);
              }
            }
          } catch (err) {
            console.error('Error processing bundle item:', err);
            // Remove the bundle item in case of an error processing
            await removeLineItem(item.key);
          }
        }
      }
    } catch (err) {
      console.error('Error fetching cart:', err);
    }
  }

  // Trigger fetchCart when necessary, reducing frequency of checks
  const t = setInterval(fetchCart, 3000);  // Increased interval to 5 seconds for better performance

})();
